<template>
  <div class="text-collapsable">
    <div
      ref="text"
      class="text-content"
      :class="{ 'text-collapsed': is_collapsed && needs_collapse }"
      :style="{ 'max-height': is_collapsed ? max_height + 'px' : null }"
      v-html="content"
    />
    <div
      v-if="needs_collapse && !selector"
      :class="link ? 'text-start pt-0' : 'text-center pt-3'"
    >
      <a
        :class="link ? 'text-muted small' : 'btn btn-outline-light'"
        href="#"
        @click.prevent.stop="() => (collapsed = !collapsed)"
      >
        {{
          collapsed ? translations.actions.SHOW_ALL : translations.actions.HIDE
        }}
        &rarr;
      </a>
    </div>
  </div>
</template>

<script>
import toggle_class from "frontend/dom/toggle_class"
import state from "frontend/state/main"
import persistence from "frontend/utils/persistence"
import scan from "rfuncs/functions/scan"
import make_translations from "workflow/utils/make_translations"

export default {
  props: ["content", "height", "link", "selector", "remove", "add", "persist"],
  data() {
    const store = this.persist
      ? persistence.make_encoder(`collapsable-${this.persist}`)
      : null

    return {
      store: store,
      collapsed: store ? store.get(true) : true,
      needs_collapse: false,
      max_height: this.height || 300,
    }
  },
  watch: {
    collapsed(v) {
      if (!v) {
        state.track_event("button_expand", "expand")
      }
      this.store && this.store.set(v)
    },
  },
  computed: {
    translations: () => make_translations("actions"),
    is_collapsed() {
      return this.collapsed && this.needs_collapse
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.needs_collapse = this.$refs.text.clientHeight > this.max_height

      if (this.needs_collapse && this.selector)
        scan(
          el =>
            el.addEventListener("click", e => {
              e.preventDefault()
              e.stopPropagation()
              this.collapsed = !this.collapsed
            }),
          toggle_class(this.selector, {
            [this.remove]: false,
            [this.add]: true,
          })
        )
    })
  },
}
</script>
